module.exports = __webpack_public_path__ + "assets/img/block-hover-14291384.png";